module.exports = __webpack_public_path__ + "img/aliens-frequency.281cb63e.png";